document.addEventListener('DOMContentLoaded', () => {
  const ingSwiper = () => {
    const element = document.querySelector('.ingredients__swiper');
    const swiperInstance = new Swiper(element, {
      slidesPerView: 1,
      watchOverflow: true,
      breakpoints: {
        1500: {
          slidesPerView: 5,
        },
        1024: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 3,
        },
        450: {
          slidesPerView: 2,
        }
      },
      navigation: {
        nextEl: '.ing-next',
        prevEl: '.ing-prev'
      }
    });

    swiperInstance.on('resize', function(instance) { 
      element.classList.toggle('slider--inactive', instance.virtualSize <= instance.size);
    });
  };

  document.addEventListener('shopify:section:load', () => {
    ingSwiper();
  });

  ingSwiper();
});